import { render, staticRenderFns } from "./AdminAnnouncement.vue?vue&type=template&id=6a2dd276&scoped=true&"
import script from "./AdminAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AdminAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2dd276",
  null
  
)

export default component.exports